<template>
  <v-container>
    <v-layout
      row
      wrap
    >
      <v-flex
        xs12
        mt-8
        class="text-center"
      >
        <v-icon
          x-large
          class="secundary500"
          color="darken-2"
        >
          mdi-check-circle-outline
        </v-icon>
      </v-flex>
      <v-flex
        py-0
        xs12
      >
        <h1
          class="text-center"
        >
          Sucesso!
        </h1>
      </v-flex>
      <v-flex
        py-2
        xs12
        class="text-center"
      >
        <span
          class="text-center subtitle"
        >
          Link enviado para {{ maskedMail }}.
        </span>
      </v-flex>
      <v-flex
        py-0
        xs12
        mb-8
        class="text-center"
      >
        Válido apenas nos próximo 5 minutos.
      </v-flex>
      <v-flex
        py-0
        xs12
        mb-8
      >
        <v-btn
          id="recoverUnderstood"
          block
          type="submit"
          class="white--text btn--text primary"
          x-large
          @click="navigateTo('Login')"
        >
          Entendi
        </v-btn>
      </v-flex>
      <v-flex
        py-0
        xs12
      >
        <v-btn
          id="resendLink"
          ref="resendLink"
          block
          depressed
          class="interface00"
          x-large
          @click="resendRecoverLink()"
        >
          REENVIAR LINK
        </v-btn>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import RouterMixin from 'Arch/mixins/RouterMixin';

export default {
  name: 'RecoverPasswordSuccess',
  components: {
  },
  mixins: [RouterMixin],
  props: {
    mail: {
      type: String,
      default: '',
    },
  },
  data: () => ({
  }),
  computed: {
    maskedMail() {
      return this.mail.replace(/^(..)(.*)(@.*)$/, (_, a, b, c) => a + b.replace(/./g, '*') + c);
    },
  },
  methods: {
    resendRecoverLink() {
      this.$router.push({ path: 'recover' }).catch(() => {});
    },
  },
};
</script>

<style scoped>
.v-icon {
  color: #2ABD49;
  height: 60px;
  width: 50px;
}

.v-btn{
  border-radius: 10px !important;
}
.container {
    width: 100%;
    padding: 0px;
}

.container .layout.row.wrap {
  width: 380px;
  margin: auto;
}
</style>
